import { createContext } from 'react';
import { useAuth } from '../hooks/useAuth';

export const AuthContext = createContext();

export const AuthProvider = (props) => {
	const { user, loading, auth, signIn, signUp, signOut, sendPasswordReset } =
		useAuth();

	return (
		<AuthContext.Provider
			value={{
				user,
				loading,
				auth,
				signIn,
				signUp,
				signOut,
				sendPasswordReset,
			}}
		>
			{props.children}
		</AuthContext.Provider>
	);
};
